import { create } from 'zustand'
import type { FilterFieldKey } from '@/lib/types/filter'

export interface FilterTarget {
  /** Filter store key: a project id, or a space id for space views. */
  projectId: string
  scope: 'project' | 'space'
  /** Properties this view can't filter on, or won't let you remove. */
  lockedFields: Array<FilterFieldKey>
}

interface ActiveFilterTargetState {
  target: FilterTarget | null
  setTarget: (target: FilterTarget) => void
  clearTarget: (projectId: string) => void
}

/**
 * The task view currently on screen, so ⌘K can apply typed filters to it
 * (design 9b). Set by the view's filter bar while it's mounted.
 */
const useActiveFilterTargetStore = create<ActiveFilterTargetState>()((set) => ({
  target: null,
  setTarget: (target) => set({ target }),
  clearTarget: (projectId) =>
    set((state) => (state.target?.projectId === projectId ? { target: null } : state)),
}))

export default useActiveFilterTargetStore
